'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dSettings$0024 from "./app.data.-General-Practice-User-Settings$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$15() {
}
export { $c_Lapp_data_AppRegisteredUser$$anon$15 as $c_Lapp_data_AppRegisteredUser$$anon$15 };
$c_Lapp_data_AppRegisteredUser$$anon$15.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$15.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$15;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$15() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$15 as $h_Lapp_data_AppRegisteredUser$$anon$15 };
$h_Lapp_data_AppRegisteredUser$$anon$15.prototype = $c_Lapp_data_AppRegisteredUser$$anon$15.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$15.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$15.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dSettings$0024.$m_Lapp_data_GeneralPracticeUserSettings$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_data_AppRegisteredUser$$anon$15 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$15, "app.data.AppRegisteredUser$$anon$15", ({
  Lapp_data_AppRegisteredUser$$anon$15: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$15 as $d_Lapp_data_AppRegisteredUser$$anon$15 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$15.js.map
